function calculateDeliveryDate(testDate = null) {
    const currentDate = testDate ? new Date(testDate) : new Date();
    let deliveryDate = new Date(currentDate);
    let daysAdded = 0;

    while (daysAdded < 2) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        
        // Only count weekdays
        if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
            daysAdded++;
        }
    }

    return {
        orderDate: currentDate,
        deliveryDate: deliveryDate
    };
}

function getOrdinalIndicator(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
}

function updateDeliveryDateDisplay(testDate = null) {
    const result = calculateDeliveryDate(testDate);
    const deliveryDateElements = document.querySelectorAll('.delivery-date');
    
    const day = result.deliveryDate.getDate();
    const ordinal = getOrdinalIndicator(day);
    const weekday = result.deliveryDate.toLocaleDateString('en-US', { weekday: 'long' });
    const month = result.deliveryDate.toLocaleDateString('en-US', { month: 'long' });
    
    const formattedDate = `${weekday} ${day}${ordinal} ${month}`;
    
    // Update all delivery date elements
    deliveryDateElements.forEach(element => {
        element.textContent = formattedDate;
    });
}

updateDeliveryDateDisplay();


